export default {
  LEGAL_CASES: "clientReference",
  CLIENTS: "name",
  FEE_EARNERS: "firstName,lastName",
  COURTS: "name"
}